export const E164_PHONE_PATTERN = /^\+[1-9]\d{6,14}$/;

const PHONE_PRESENTATION_PATTERN = /^[+\d\s().-]+$/;

export const normalizePhoneNumberToE164 = (value) => {
  const input = String(value || "").trim();
  if (!input || !PHONE_PRESENTATION_PATTERN.test(input)) return null;

  const compact = input.replace(/[\s().-]/g, "");
  let normalized = compact;

  if (!compact.startsWith("+")) {
    if (/^\d{10}$/.test(compact)) {
      normalized = `+1${compact}`;
    } else if (/^1\d{10}$/.test(compact)) {
      normalized = `+${compact}`;
    } else {
      return null;
    }
  }

  return E164_PHONE_PATTERN.test(normalized) ? normalized : null;
};

export const formatPhoneNumberForDisplay = (value) => {
  const normalized = normalizePhoneNumberToE164(value);
  if (!normalized) return String(value || "");

  const domestic = normalized.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  return domestic ? `(${domestic[1]}) ${domestic[2]}-${domestic[3]}` : normalized;
};
